import { useGetCurrentPageData } from '~/behaviors/hooks/currentPage/useGetCurrentPageData';

export const useGetCurrentPageAiContext = (args?: { indentationLevel?: number }) => {
  let indentationLevel = args?.indentationLevel || 0;
  if (indentationLevel < 0) {
    console.warn('useGetCurrentPageAiContext: indentationLevel must be greater than 0', indentationLevel);
    indentationLevel = 0;
  }

  const indent = '  '.repeat(indentationLevel);
  const currentPageData = useGetCurrentPageData();
  const aiContext = Object.values(currentPageData).map((dataSlice) => {
    let title = dataSlice.title ? `${dataSlice.title}:` : 'Untitled page content:';
    let formattedData = '';

    const data = dataSlice.data;

    if (Array.isArray(dataSlice.data)) {
      if (data.length === 0) {
        return '';
      }
      formattedData = data
        .map((item) => {
          if (item === null || item === undefined || item === '') {
            return null;
          }
          return `- ${JSON.stringify(item)}`;
        })
        .filter(Boolean)
        .join('\n' + '  '.repeat(indentationLevel + 1));
    } else if (typeof dataSlice.data === 'object' && data !== null) {
      formattedData = JSON.stringify(data);
    } else if (data !== null && data !== undefined && data !== '') {
      formattedData = data;
    } else {
      return '';
    }

    return `
${indent}${title}
  ${indent}${formattedData}
        `;
  });

  return aiContext.filter(Boolean).join('\n');
};
